// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-ticket-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-top: 40px;
  width: 100%;
  min-height: 100vh;
  gap: 25px;
}

.title-ticket-container {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  flex-direction: column;
}

.input-ticket-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 300px;
  height: 100px;
  border: 1px solid var(--dark-blue);
  position: relative;
  border-radius: 10px;
}

.select-ticket-button {
width: 250px;
padding: 10px;
box-sizing: border-box;
border: none;
border-radius: 6px;
background-color: var(--dark-blue);
font-family: Poppins;
color: white;
font-weight: bold;
letter-spacing: 1px;
font-size: 1.2rem;
cursor: pointer;
}

.input-file {
  position: absolute;
  z-index:999;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.upload-ticket-container p {
  width: 90%;
  text-align: center;
  margin: 0;
  font-style: italic;
  font-size: 14px;
  color: var(--dark-blue);
}
.ticket-button {
  margin-top: 20px;
  width: 250px;
  padding: 8px;
  font-size: 1.2rem;
  font-family: Poppins;
  font-weight: bold;
  cursor: pointer;
  border: none;
  background-color: var(--dark-blue);
  box-shadow: 0px 0px 6px 2px var(--dark-blue);
  color: white;
  border-radius: 6px;
  animation: fadeIn 0.4s ease-in;
}

@keyframes fadeId {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.upload-ticket-container h1 {
  font-size: 3rem;
  font-family: Poppins;
  font-weight: 700;
  font-style: italic;
  letter-spacing: 2px;
  color: var(--dark-blue);
  margin-bottom: 0;
}

.upload-ticket-container .error-message {
  width: 80%;
  text-align: center;
  font-size: 1rem;
  font-family: Poppins;
  font-weight: 700;
  letter-spacing: -1px;
  color: red;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/routes/UploadTicket/UploadTicket.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;AACA,YAAY;AACZ,aAAa;AACb,sBAAsB;AACtB,YAAY;AACZ,kBAAkB;AAClB,kCAAkC;AAClC,oBAAoB;AACpB,YAAY;AACZ,iBAAiB;AACjB,mBAAmB;AACnB,iBAAiB;AACjB,eAAe;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["@import url('/src/App.css');\n.upload-ticket-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  padding-top: 40px;\n  width: 100%;\n  min-height: 100vh;\n  gap: 25px;\n}\n\n.title-ticket-container {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.input-ticket-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 300px;\n  height: 100px;\n  border: 1px solid var(--dark-blue);\n  position: relative;\n  border-radius: 10px;\n}\n\n.select-ticket-button {\nwidth: 250px;\npadding: 10px;\nbox-sizing: border-box;\nborder: none;\nborder-radius: 6px;\nbackground-color: var(--dark-blue);\nfont-family: Poppins;\ncolor: white;\nfont-weight: bold;\nletter-spacing: 1px;\nfont-size: 1.2rem;\ncursor: pointer;\n}\n\n.input-file {\n  position: absolute;\n  z-index:999;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.upload-ticket-container p {\n  width: 90%;\n  text-align: center;\n  margin: 0;\n  font-style: italic;\n  font-size: 14px;\n  color: var(--dark-blue);\n}\n.ticket-button {\n  margin-top: 20px;\n  width: 250px;\n  padding: 8px;\n  font-size: 1.2rem;\n  font-family: Poppins;\n  font-weight: bold;\n  cursor: pointer;\n  border: none;\n  background-color: var(--dark-blue);\n  box-shadow: 0px 0px 6px 2px var(--dark-blue);\n  color: white;\n  border-radius: 6px;\n  animation: fadeIn 0.4s ease-in;\n}\n\n@keyframes fadeId {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.upload-ticket-container h1 {\n  font-size: 3rem;\n  font-family: Poppins;\n  font-weight: 700;\n  font-style: italic;\n  letter-spacing: 2px;\n  color: var(--dark-blue);\n  margin-bottom: 0;\n}\n\n.upload-ticket-container .error-message {\n  width: 80%;\n  text-align: center;\n  font-size: 1rem;\n  font-family: Poppins;\n  font-weight: 700;\n  letter-spacing: -1px;\n  color: red;\n  margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
